export default "__VITE_ASSET__CxPf6l_V__"